__turbopack_context__.v({
  "badge": "vzx6VG_badge",
  "columns": "vzx6VG_columns",
  "crossIcon": "vzx6VG_crossIcon",
  "featureDetails": "vzx6VG_featureDetails",
  "featureItemIcon": "vzx6VG_featureItemIcon",
  "features": "vzx6VG_features",
  "featuresContainer": "vzx6VG_featuresContainer",
  "featuresList": "vzx6VG_featuresList",
  "featuresListItem": "vzx6VG_featuresListItem",
  "itemDescription": "vzx6VG_itemDescription",
  "moreInformationLink": "vzx6VG_moreInformationLink",
  "optionColumn": "vzx6VG_optionColumn",
  "optionColumnFooter": "vzx6VG_optionColumnFooter",
  "optionColumnHeading": "vzx6VG_optionColumnHeading",
  "optionColumnSelected": "vzx6VG_optionColumnSelected",
  "optionFeaturesList": "vzx6VG_optionFeaturesList",
  "optionFeaturesListItem": "vzx6VG_optionFeaturesListItem",
  "percentage": "vzx6VG_percentage",
  "percentageSection": "vzx6VG_percentageSection",
  "selectedText": "vzx6VG_selectedText",
  "table": "vzx6VG_table",
  "topInfo": "vzx6VG_topInfo",
});
